import React, { useRef, useState, KeyboardEvent, Dispatch } from "react";
import { logEvent } from "../ga/ga-event-logger";
import { doLogin } from "../loaders/auth-loaders";
import { setToken } from "../loaders/basic-loader";
import { AuthAction, useIsAwr } from "./AuthContext";

export function Login({dispatch}:{dispatch:Dispatch<AuthAction>}){
    const [error, setError] = useState(null);

    var email = useRef<HTMLInputElement>()
    var pass = useRef<HTMLInputElement>()

    async function onLogin(){
       var user = null;
       try {
            user = await doLogin(email.current.value, pass.current.value);
            logEvent({type:"user_login", params:{}})
       }catch(e){
            setError(e.error || "Erro ao acessar o servidor");
            return;
       }
        
       setToken(user.token);
       dispatch({type:"setUser", payload: user})       
    }

    function enterLogin(e:KeyboardEvent){
        if(e.key == "Enter")
            onLogin();
    }

    const awr = useIsAwr()

    return (
        <div className="login-page">
            <div className="login-form card">
                  <div className="card-body">
                        {!awr && <h3 className="text-center">
                            <img src="https://dash.proglingo.com/notications/icon-1.png" width="40" height="40" />
                            Meta Ads Report
                        </h3>}
                        {awr && <h3 className="text-center">
                            <img src="https://dash.awrdigital.com.br/reports/awr-logo.png" style={{verticalAlign:"top"}}/> 
                            Dashboard
                        </h3>}

                    <div className="form-floating mb-3 mt-3">
                        <input ref={email} type="email" className="form-control" id="floatingInput" placeholder="email or username" />
                        <label htmlFor="floatingInput">Usuário</label>
                    </div>
                    <div className="form-floating">
                        <input ref={pass} type="password" className="form-control" id="floatingPassword" placeholder="Password" onKeyUp={enterLogin} />
                        <label htmlFor="floatingPassword">Senha</label>
                    </div>
                    {error && <div className="alert alert-danger mt-3">
                        <i className="fa fa-exclamation-triangle mr-2"></i> <b>Erro: </b>  {"Dados inválidos!"}
                    </div>}
                    
                    <div className="submit mt-3 text-right">
                        <button className="btn btn-primary" onClick={onLogin}>Entrar</button>
                    </div>
                </div>  
            </div>
        </div>
    );
}